import * as React from "react";
import { useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { User } from "appz";
import { fetchUsers } from "page/user/service";
import { AdminHeader } from "page/admin/admin-header";
import * as styles from "./user-list.css";
import * as buttonStyles from "../user.css";
import { StyledPagination } from "common/styled-pagination";
import { PaginationOptions } from "burde";
import { UserRow } from "./user-row";
import { useDebounce } from "hooks/use-debounce";

interface UserListTranslations {
    Admin_Dashboard_Users: string;
    Admin_Dashboard_Users_Username: string;
    Admin_Dashboard_Users_Email: string;
    Admin_Dashboard_Users_Roles: string;
    Admin_Dashboard_Users_New: string;
    Admin_Order_Search: string;
    Loading: string;
}

const UserList = (
    props: UserListTranslations & RouteComponentProps,
): React.ReactElement => {
    const [users, setUsers] = useState<User[]>([]);
    const [toastMessage, setToastMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState<PaginationOptions>({
        pageNumber: 1,
        totalNumber: 0,
        numberOfPages: 0,
        searchText: "",
    });
    const { numberOfPages, pageNumber, searchText } = pagination;
    const debouncedSearchValue = useDebounce(searchText, 300);

    const editUser = (id: string) => {
        const { history } = props;
        history.push(`/admin/user/edit/${id}`);
    };

    useEffect(() => {
        const { state } = props.location;

        if (state && state.toastMessage && state.toastMessage !== "") {
            setToastMessage(state.toastMessage);
        }

        setTimeout(() => {
            setToastMessage("");
        }, 3000);

        props.history.replace({
            pathname: `/user/list`,
        });

        getUsers();
    }, [pageNumber, debouncedSearchValue]);

    const getUsers = async () => {
        setLoading(true);
        const { success, data } = await fetchUsers(
            pagination.pageNumber,
            30,
            pagination.searchText,
        );
        const { pageNumber, totalNumber, pages } = data;

        if (success) {
            setUsers(data.users);
            setPagination({
                ...pagination,
                pageNumber,
                totalNumber,
                numberOfPages: pages,
            });
            setLoading(false);
        }
        setLoading(false);
    };

    return (
        <div className={"container mt-4"}>
            <AdminHeader title={props.Admin_Dashboard_Users} />

            <input
                type="text"
                onChange={(e) =>
                    setPagination({ ...pagination, searchText: e.target.value })
                }
                placeholder={props.Admin_Order_Search}
                className={styles.searchField}
                value={searchText}
            />

            {loading ? (
                <div style={{ textAlign: "center" }}>
                    <i className="fa fa-spinner fa-spin fa-2x"></i>
                    <p>{props.Loading}</p>
                </div>
            ) : (
                <div className={"mt-4"}>
                    <table className={`${styles.userTable} table`}>
                        <thead>
                            <tr>
                                <th>{props.Admin_Dashboard_Users_Username}</th>
                                <th className={styles.visibleLg}>
                                    {props.Admin_Dashboard_Users_Email}
                                </th>
                                <th>{props.Admin_Dashboard_Users_Roles}</th>
                                <th />
                            </tr>
                        </thead>
                        <UserRow
                            users={users}
                            editUser={editUser}
                            rowStyle={styles.userRow}
                            tableDataStyle={styles.visibleLg}
                        />
                    </table>
                    {toastMessage !== "" && (
                        <div className={styles.toast}>
                            <div>
                                <i className="fa fa-check"></i>
                                {toastMessage}
                            </div>
                            <i
                                className={"fa fa-times " + styles.closeToast}
                                onClick={() => {
                                    setToastMessage("");
                                }}></i>
                        </div>
                    )}
                </div>
            )}

            <div style={loading ? { pointerEvents: "none", opacity: 0.4 } : {}}>
                <StyledPagination
                    numberOfPages={numberOfPages}
                    setPagination={setPagination}
                    paginationOptions={pagination}
                />
            </div>

            <button
                className={"btn float-right mb-4 " + buttonStyles.buttonBlue}
                onClick={() => editUser("")}>
                {props.Admin_Dashboard_Users_New}
            </button>
        </div>
    );
};

export { UserList };
